import { useTranslation } from '../i18n';
import LogoMark from './LogoMark';

export default function FooterNB() {
  const { t } = useTranslation();

  return (
    <footer className="bg-nb-black">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {/* Brand + tagline */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-2">
              <LogoMark size={28} className="text-nb-yellow" />
              <p className="font-nb font-bold text-2xl text-nb-yellow">
                Tellow Up
              </p>
            </div>
            <p className="text-sm text-nb-white opacity-70">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Product links */}
          <div>
            <h4 className="text-sm font-bold text-nb-white uppercase tracking-wider mb-3 md:mb-4">
              {t('footer.product')}
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/en/track" className="text-sm text-nb-white hover:underline hover:decoration-nb-yellow hover:decoration-2 transition-colors">
                  {t('footer.trackRepair')}
                </a>
              </li>
              <li>
                <a href="/en/register" className="text-sm text-nb-white hover:underline hover:decoration-nb-yellow hover:decoration-2 transition-colors">
                  {t('footer.forShops')}
                </a>
              </li>
            </ul>
          </div>

          {/* Support links */}
          <div>
            <h4 className="text-sm font-bold text-nb-white uppercase tracking-wider mb-3 md:mb-4">
              {t('footer.support')}
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/en/support" className="text-sm text-nb-white hover:underline hover:decoration-nb-yellow hover:decoration-2 transition-colors">
                  {t('footer.helpCenter')}
                </a>
              </li>
              <li>
                <a href="/en/contact" className="text-sm text-nb-white hover:underline hover:decoration-nb-yellow hover:decoration-2 transition-colors">
                  {t('footer.contactUs')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal links */}
          <div>
            <h4 className="text-sm font-bold text-nb-white uppercase tracking-wider mb-3 md:mb-4">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/en/privacy" className="text-sm text-nb-white hover:underline hover:decoration-nb-yellow hover:decoration-2 transition-colors">
                  {t('footer.privacy')}
                </a>
              </li>
              <li>
                <a href="/en/terms" className="text-sm text-nb-white hover:underline hover:decoration-nb-yellow hover:decoration-2 transition-colors">
                  {t('footer.terms')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-nb-white border-opacity-10 mt-6 md:mt-10 pt-4 md:pt-6 text-center">
          <p className="text-xs text-nb-white text-opacity-50">
            &copy; {new Date().getFullYear()} Tellow Up. {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
